import { Mui } from '@osu/react-ui'; 
import { useState } from 'react';
import MenuDialogBase from "./MenuDialogBase";
import { useGetApplicationDetailsQueryState, useApplicationUnassignReviewMutation } from "../../../services/graphql/api";
import { getApplDetailParams } from "../../../util/functions";

export default function DialogUnassign({ menuItemAndClose }) {
    const params = getApplDetailParams();
    const { data } = useGetApplicationDetailsQueryState(params);
    const reviewers = data?.configuration.unassignableReviewers ?? [];

    const [apiCall, result] = useApplicationUnassignReviewMutation();
    const [reviewer, setReviewer] = useState(null);

    const variables = { reviewerEmployeeIdFrom: reviewer?.id, ...params };
    const isDisabled = !reviewer;
    const buttons = [{ label: "Unassign", apiCall, variables, isDisabled }];
    const message = `You are unassigning ${reviewer?.name ?? "a reviewer"} from this applicant.`;

    return (
        <MenuDialogBase menuItemAndClose={menuItemAndClose}
            apiCall={apiCall}
            buttons={buttons}
            result={result}
            extraContent={(
                <>
                    {message}
                
                    <br/>
                    <br/>
                    
                    <Mui.FormControl fullWidth required>
                        <Mui.InputLabel id="dialog-unassign-choose-reviewer">Choose Reviewer</Mui.InputLabel>
                        <Mui.Select
                            disabled={result?.isLoading || result.isSuccess}
                            sx={{ width: "100%" }}
                            label="Choose Reviewer"
                            labelId="dialog-unassign-choose-reviewer"
                            value={reviewer?.id ?? ""}
                            onChange={event => setReviewer(reviewers.find(r => r.id === event.target.value))}>
                                {reviewers.map((item, index) => <Mui.MenuItem key={index} value={item.id}>{item.name}</Mui.MenuItem>)}
                        </Mui.Select>
                    </Mui.FormControl>
                </>
            )}
        />
    );
}